import { render, staticRenderFns } from "./msgmodal.vue?vue&type=template&id=4e55732b&scoped=true"
import script from "./msgmodal.vue?vue&type=script&lang=js"
export * from "./msgmodal.vue?vue&type=script&lang=js"
import style0 from "./msgmodal.vue?vue&type=style&index=0&id=4e55732b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e55732b",
  null
  
)

export default component.exports